<template>
  <div :class="device === 'mobile' ? 'reset-pwd mobile' : 'reset-pwd'">

    <h3 class="title">修改手机号码</h3>
    <a-form class="form" :form="form">

      <!-- 账号 -->
      <a-form-item>
        <a-input
          v-decorator="['userName',{ rules: [{ required: true, message: '新手机号码不能为空!' }] },]"
          placeholder="新手机号码"
        ><a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" /></a-input>
      </a-form-item>

      <!-- 验证码 -->
      <a-form-item>
        <div class="code">
          <a-input
          v-decorator="['code',{ rules: [{ required: true, message: '请输入验证码!' }] },]"
          placeholder="请输入验证码"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input>
        <a-button type="primary" :disabled="countDownLoading" @click="getCode">{{countDownText}}</a-button>
        </div>
      </a-form-item>

      <!-- 新密码 -->
      <a-form-item>
        <a-input
          v-decorator="['password1',{ rules: [{ required: true, message: '请输入登录密码!' }] },]"
          placeholder="登录密码"
          type="password"
        ><a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" /></a-input>
      </a-form-item>

      <!-- 重置密码按钮 -->
      <a-form-item>
        <a-button type="primary" :loading="loading" block @click="handleSubmit">{{buttonText}}</a-button>
      </a-form-item>
      
    </a-form>
  </div>
</template>

<script>
export default {
  props: [ 'device' ],
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      buttonText: '确认',
      timer: null,
      countDownText: '获取验证码', // 获取验证码按钮文本
      countDownLoading: false
    };
  },

  created() {
    this.countDown()
  },

  methods: {

    // 倒计时
    countDown() {
      let that = this
      try {
        let sendCode = that.$pub.getCookie('reset_time')
        if(sendCode) {
          that.countDownLoading = true
          let count = parseInt(sendCode)
          that.timer = setInterval(() => {
            that.$cookies.set('reset_time', count, { expires: 0.5 })
            count--
            that.countDownText = `剩余${count}秒`
            if(count <= 0) {
              that.countDownText = '获取验证码'
              that.countDownLoading = false
              that.$cookies.remove('reset_time')
              clearInterval(this.timer)
              that.timer = null
            }
          }, 1000);
        }
      } catch (error) {
        console.log(error)
      }
    },

    // 获取验证码
    getCode() {
      let that = this
      try {
        that.$cookies.set('reset_time', 60, { expires: 0.5 })
        that.countDown()
      } catch (error) {
        console.log(error)
      }
    },

    // 设置按钮加载状态跟文字
    setBtnStatus(status, text) {
      this.loading = status
      this.buttonText = text
    },

    // 提交按钮点击回调
    handleSubmit() {
      let that = this
      try {
        that.setBtnStatus(true, '正在提交')
        that.form.validateFields( (err, params) => {
          if(!err) {
            let pwd1 = that.$pub.setMD5(params.password1)
            that.$message.success('提交成功')
            setTimeout(() => {
              that.setBtnStatus(false, '确认')
              that.$router.push('/account/login')
            }, 1000);
          } else {
            that.setBtnStatus(false, '确认')
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
};
</script>

<style lang="less" scoped>
.reset-pwd {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f0f2f5 no-repeat;
  background-position: 0 132px;
  background-image: url('../../assets/images/account/big_shape2.png');

  &.mobile {
    .description, .title, .form { width: 95%;}
  }

  .title {
    font-weight: bold;
    font-size: 22px;
    background-color: #fff;
    width: 400px;
    text-align: center;
    padding-top: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .form {
    width: 400px;
    background: #fff;
    padding: 15px 30px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    /deep/.ant-input, .ant-btn {height: 38px;}

    .code {
      display: flex;
      align-items: center;
      justify-content: space-between;

      /deep/.ant-input {width: calc(100% - 5px);}
    }
  }
}
</style>
